const config = require("../config");
const moment = require('moment');
const {
  downloadReport: downloadReportService,
  getAsset
} = require("../services/general");
const { revisionService } = require("../services/revisionPage");


const handleCurrentStep = (stepName, stepValue) => {
  localStorage.setItem(stepName, JSON.stringify(stepValue));
};

const handleUserData = (data) => {
  const _userData = JSON.parse(localStorage.getItem("userData"));

  if (_userData === null || _userData === undefined) {
    localStorage.setItem("userData", JSON.stringify(data));
  } else {
    const newData = data;

    const mergeNewValues = Object.assign(_userData, newData);

    localStorage.setItem("userData", JSON.stringify(mergeNewValues));
  }
};

const handleSurveyData = (data) => {
  const _surveyData = JSON.parse(localStorage.getItem("surveyData"));

  if (data === null || data === undefined) {
    localStorage.removeItem("surveyData");
  } else if (_surveyData === null || _surveyData === undefined) {
    localStorage.setItem("surveyData", JSON.stringify(data));
  } else {
    const newData = data;

    const mergeNewValues = Object.assign(_surveyData, newData);

    localStorage.setItem("surveyData", JSON.stringify(mergeNewValues));
  }
};

const handleModifyAnswer = (data) => {
  let _userData = JSON.parse(localStorage.getItem("userData"));

  for (let test of _userData["testsResults"]) {
    if (
      test.testId === data.testId &&
      test.groupId === data.groupId &&
      test.questionId === data.questionId
    ) {
      test.answer = data.selectedAnswer;
    }
  }

  localStorage.setItem("userData", JSON.stringify(_userData));
};

const handleInitialTimeStamp = (time) => {
  localStorage.setItem("initialTimeStamp", JSON.stringify(time));
};

const handleCurrentTimeStamp = (time) => {
  localStorage.setItem("timeStamp", JSON.stringify(time));
};

export const checkAndMarkSurveyAsPending = async ({
  isBattery,
  currentExamId,
  test,
  testsResults
}) => {
  if (!currentExamId || !test || !testsResults) return;

  const markAsPending = async () => {
    try {
      await revisionService.markSurveyAsPendingSubmission({ admissionPatientExamId: currentExamId });
    } catch (error) {
      console.error('Error marking survey as pending submission:', error);
    }
  };

  const sameExamGroups = test.groups.filter(
    group => group.admission_patient_exam === currentExamId
  );

  const answeredGroupIds = new Set(
    testsResults
      .filter(result => result.admissionPatientExam === currentExamId)
      .map(result => result.groupId)
  );
  const allGroupsAnswered = sameExamGroups.every(group =>
    answeredGroupIds.has(group.id)
  );

  if (allGroupsAnswered) {
    await markAsPending();
  }
};

export const markSurveysAsInitialized = (group) => {
  const updatedUserData = JSON.parse(localStorage.getItem('userData'));
  const countTest = updatedUserData.countTest;
  if (updatedUserData.tests && updatedUserData.tests[countTest]) {
    const currentTest = updatedUserData.tests[countTest];
    currentTest.groups = currentTest.groups.map(testGroup => {
        if (testGroup.admission_patient_exam === group.admission_patient_exam) {
          return {
              ...testGroup,
              admission_patient_exam_state: 'occupied'
          };
        }
        return testGroup;
    });
    handlers.handleUserData(updatedUserData);
  }
}

const base642Download = (pdf, type, name) => {
  const linkSource = `${type},${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = name;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

const url2Base64 = (url) => {
  return fetch(url)
    .then(res => res.blob())
    .then(blob => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data.split(',')[1]);
        };
        reader.onerror = () => {
          reject('Error converting file to base64');
        };
      });
    });
};

const base642Open = (pdf, fileName) => {
  const url = `data:application/pdf;base64,${pdf}`;
  fetch(url)
    .then(res => res.blob())
    .then(blob => {
      if (window?.navigator?.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName || "informe.pdf");
      } else {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      }
    })
}

const downloadReport = async (pdf, fileName) => {
  let pdfToDownload = pdf;

  if (pdf.document_url) {
    pdfToDownload = await url2Base64(pdf.document_url);
  }

  const type = 'data:application/pdf;base64';
  const name = fileName || 'informe.pdf';
  base642Download(pdfToDownload, type, name);
}

const urlDownload = (url, message, name = "informe.pdf") => {
  if (url.includes('missing.png') && message) {
    message.error({
      content: `No existe el archivo`,
      style: {
        marginTop: "35vh",
        fontSize: 16,
      },
    });
  } else {
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = name;
    downloadLink.target = "_blank";
    downloadLink.click();
  }
};

const urlDicomDownload = (url) => {
  const newWindow = window.open(`${config.dicomUrl}?url=${url}`, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
};

const replaceUrlQueryString = (navigate, data) => {
  const params = new URLSearchParams({ ...data }).toString();
  navigate({
    search: "?" + params,
  });
};

const goBack = (location, navigate, path) => {
  navigate({
    pathname: location.state
      ? location.state.from
      : path,
    search: location.state
      && location.state.search
      ? location.state.search
      : null
  });
}

const removeEmpties = (object) => {
  Object.keys(object).forEach(key => {
    if (object[key] === undefined || object[key] === 'undefined') {
      delete object[key];
    }
  });
}

const isJSON = (text) => {
  let result = false;
  try {
    JSON.parse(text);
    result = true;
  } catch (err) { }
  return result;
};

const { format } = require('rut.js');

const formatDocument = (number) => {
  return format(number);
};

const formatDate = (date) => {
  return moment(date).format('DD-MM-YYYY');
};

const documentType = (type) => {
  switch (type) {
    case 'rut':
      return 'RUT';
    case 'passport':
      return 'Pasaporte';
    case 'ce':
      return 'Carnet de extranjería';
    case 'dni':
      return 'DNI';
    case 'ruc':
      return 'RUC';
    default:
      return 'RUT';
  };
};

const downloadSignedReport = async ({
  id,
  type,
  occupationalType,
  fileName,
  action,
  admission_patient_exam_id,
  variant,
}) => {
  if (type === 'signed') {
    const response = await getAsset({
      id,
      type: 'MedicalConsultationDetail',
      field: 'document'
    });
    if (action === 'open') {
      urlDownload(response.document_url, null, fileName);
    } else {
      downloadReport(response, fileName);
    }
  } else {
    const response = await downloadReportService({
      report_type: type,
      consultation_id: id,
      occupational_type: occupationalType,
      admission_patient_exam_id,
      variant,
    });
    if (response) {
      const pdfData = response.pdf || response;
      if (action === 'open') {
        handlers.base642Open(pdfData, fileName);
      } else {
        await handlers.downloadReport(pdfData, fileName);
      }
    }
  }
};

export const handlers = {
  handleCurrentStep,
  handleUserData,
  handleModifyAnswer,
  handleInitialTimeStamp,
  handleCurrentTimeStamp,
  base642Open,
  base642Download,
  replaceUrlQueryString,
  urlDownload,
  goBack,
  removeEmpties,
  isJSON,
  formatDocument,
  handleSurveyData,
  urlDicomDownload,
  formatDate,
  documentType,
  url2Base64,
  downloadReport,
  downloadSignedReport,
  checkAndMarkSurveyAsPending,
  markSurveysAsInitialized,
};
